import { render, staticRenderFns } from "./LeadDirectCreateModal.vue?vue&type=template&id=245f3551&"
import script from "./LeadDirectCreateModal.vue?vue&type=script&lang=js&"
export * from "./LeadDirectCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports